import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar/Navbar";
import HeroSection from "./Main Section/HeroSection";
import Footer from "./Footer/Footer";
import "./App.css";
import App1 from "./section2/app1";
import CardLayout from "./Products/pro1";
import TestimonialSection from "./Testimonals/Test";
import ExecutiveTeam from "./Executive Team/Exec1";
import Services from "./Services/Ser1";
import Questions from "./Questions/Que1";
import WhyChooseUs from "./Trusted AI Partners/Trust";
import { FaChevronUp } from "react-icons/fa";
import ResearchToProduction from "./components/ResearchToProduction";
import AIStrategyFlow from "./components/AIStrategyFlow";
import ProjectStartSection from "./components/ProjectStartSection";
import SupportedSectors from "./components/SupportedSectors";
import ContactSupport from "./components/ContactSupport";
import Contact from "./components/Contact";
import ContactModal from "./Main Section/ContactModal";
import ScrollToTop from "./components/ScrollToTop";

const ServicesPage = React.lazy(() => import("./pages/ServicesPage"));
const ProductPage = React.lazy(() => import("./pages/ProductPage"));
const AboutPage = React.lazy(() => import("./pages/AboutPage"));
const Careers = React.lazy(() => import("./pages/Careers"));
const EnrollInternship = React.lazy(() => import("./pages/EnrollInternship"));
const ProjectGuidance = React.lazy(() => import("./pages/ProjectGuidance"));
const Training = React.lazy(() => import("./pages/Training"));

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      className="scroll-to-top"
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <FaChevronUp />
    </button>
  );
};

function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (isLocked) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => document.body.classList.remove("modal-open");
  }, [isLocked]);
}

// Home page component
function Home({ onOpenContactModal }) {
  return (
    <>
      <Helmet>
        <title>PINKMOON Technologies | Innovative IT Solutions & Consulting</title>
        <meta name="description" content="PINKMOON Technologies is a leading IT consulting firm providing innovative digital solutions, internships, training, and project guidance for all." />
        <meta property="og:title" content="PINKMOON Technologies | Innovative IT Solutions & Consulting" />
        <meta property="og:description" content="Leading IT consulting firm providing innovative digital solutions, internships, and training." />
      </Helmet>
      <Navbar />
      <HeroSection onOpenContactModal={onOpenContactModal} />
      <div id="about-us">
        <App1 />
      </div>
      <WhyChooseUs />
      <CardLayout />
      <div id="enroll-training">
        <Services />
      </div>
      <div id="industries">
        <SupportedSectors />
      </div>
      <div id="executive-team">
        <ExecutiveTeam />
      </div>
      <div id="testimonials">
        <TestimonialSection />
      </div>
      <ProjectStartSection />
      <div id="case-studies">
        <ResearchToProduction />
      </div>
      <div id="collaboration">
        <AIStrategyFlow />
      </div>
      <div id="faq">
        <Questions />
      </div>
      <div id="contact">
        <ContactSupport />
      </div>
      <Footer />
    </>
  );
}

// Contact page component
function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us | PINKMOON Technologies</title>
        <meta name="description" content="Get in touch with PINKMOON Technologies for innovative IT solutions, consulting services, and career-building opportunities today." />
        <meta property="og:title" content="Contact Us | PINKMOON Technologies" />
        <meta property="og:description" content="Contact PINKMOON Technologies for IT consulting and career opportunities." />
      </Helmet>
      <Navbar />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  const API_URL = process.env.REACT_APP_API_URL;
  console.log("API_URL =", API_URL);
  const [showContactModal, setShowContactModal] = useState(false);
  useBodyScrollLock(showContactModal);
  const openContactModal = () => setShowContactModal(true);
  const closeContactModal = () => setShowContactModal(false);

  return (
    <>
      <ScrollToTop />
      <React.Suspense
        fallback={
          <div
            style={{
              minHeight: "80vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#080c14",
              color: "#60a5fa",
              fontSize: "1rem",
              fontWeight: "600",
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          <Route
            path="/"
            element={<Home onOpenContactModal={openContactModal} />}
          />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services/:serviceId?" element={<ServicesPage />} />
          <Route path="/products/:productId" element={<ProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/enroll-internship" element={<EnrollInternship />} />
          <Route path="/project-guidance" element={<ProjectGuidance />} />
          <Route path="/training" element={<Training />} />
        </Routes>
      </React.Suspense>
      <ScrollToTopButton />
      {showContactModal && (
        <ContactModal onClose={closeContactModal} variant="home" />
      )}
    </>
  );
}

export default App;
